var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAccordionDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07264 9.49531L11.7372 14.8843C11.8707 15.0386 12.1278 15.0386 12.2628 14.8843L16.9274 9.49531C17.1006 9.29436 16.9444 9 16.6646 9H7.33542C7.0556 9 6.89935 9.29436 7.07264 9.49531Z",
    fill: "#FFF97D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAccordionDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-accordion-down.dbcfb86ad5da12c7de4f993a95473df1.svg";